import TopProductList from './TopProductList';

export {TopProductList}



// WEBPACK FOOTER //
// ./components/home/sub-view/TopProduct/index.js